import { SavePaymentMethodRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'

export const PaymentMethodSave = (_context: NoContext) => SavePaymentMethodRequestSchema
